import AccountLayout from "../layouts/AccountLayout"
import './../styles/payment.css';
import { PiBankFill } from "react-icons/pi";
import { BiSolidCreditCardFront } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export const Payment = () => {
    const navigate = useNavigate();

    return (
        <AccountLayout title={'Nạp tiền'}>
            <div className="user-payment-container">
                <div className="deposit-button-container">
                    <p>Nạp tiền qua ngân hàng (Chuyển khoản)</p>
                    <button onClick={() => navigate('/payment/bank-transfer')} className="user-deposit-button"><PiBankFill /></button>
                </div>
                <div className="deposit-button-container">
                    <p>Nạp tiền qua thẻ cào</p>
                    <button onClick={() => navigate('/payment/card-transfer')} className="user-deposit-button"><BiSolidCreditCardFront /></button>
                </div>
            </div>
        </AccountLayout>
    )
}